import React, { useState } from "react";
import logo from "../../../Assets/navLogo/logo3.png";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="navbar">
      <div className="head-bg d-flex justify-content-between p-3">
        <div className="logo">
          {/*<img src={logo} alt="" className="logo"/>*/}
          <img src={logo} alt=""/>
        </div>
        <div className={`${menuOpen === true ? "ResponsiveNav" : "navLinks"}`}>
          <ul className="d-flex justify-content-center align-items-center gap-5 m-0 nav-link">
            <Link to='/' >
              <li className="text-decoration-none d-flex">Home</li>
            </Link>
            <Link to='/service'>
              <li className="d-flex text-decoration-none">Service</li>
            </Link>
            <Link to='/about'>
              <li className="d-flex text-decoration-none">About</li>
            </Link>
            <Link to='/appoinment'>
              <li className="d-flex text-decoration-none">Appoinment</li>
            </Link>
            <Link to='/contact'>
              <li className="d-flex text-decoration-none">Contact</li>
            </Link>
          </ul>
        </div>
        <div className="menu-toggle">
          <GiHamburgerMenu onClick={toggleMenu} size="1.6rem" />
        </div>
      </div>
    </div>
  );
};

export default Header;
